var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shownVideoPoster),expression:"shownVideoPoster"}],staticClass:"wt-infobar-toolbar"},[_c('wt-video-poster-toggle',{ref:"videoPosterToggle",attrs:{"asset":_vm.workModel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }